<template>
    <dl
        class="flex flex-col space-y-6 xl:flex-row xl:space-y-0 xl:space-x-12"
        data-spec-class="description-list"
    >
        <slot>
            <BaseDescriptionListItem
                v-for="(item, i) in items"
                :key="i"
            >
                <slot
                    name="item"
                    v-bind="item"
                />
                <BaseDescriptionListTitle v-if="!$slots.item">
                    {{ item.title }}
                </BaseDescriptionListTitle>
                <BaseDescriptionListData v-if="!$slots.item">
                    {{ item.data }}
                </BaseDescriptionListData>
            </BaseDescriptionListItem>
        </slot>
    </dl>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { DescriptionListItem } from '@/types';
import BaseDescriptionListItem from './BaseDescriptionListItem.vue';
import BaseDescriptionListTitle from './BaseDescriptionListTitle.vue';
import BaseDescriptionListData from './BaseDescriptionListData.vue';

defineProps<{
    items?: DescriptionListItem[];
}>();
</script>
